<div
  class="nav-items"
  [ngClass]="{ expanded: mobileExpanded, collapsed: collapsed }"
>
  @for (item of navItems(); track item) { @if (item.items) { @if
  (item.isVisible(user)) {
  <div class="accordion">
    <a
      class="accordion-button menu-item"
      id="{{ item.title }}"
      [ngClass]="{ active: item.isChildActive(), collapsed: !item.expanded }"
      data-bs-toggle="collapse"
      href="#"
      [attr.data-bs-target]="'#' + item.icon"
      aria-expanded="true"
      [attr.aria-controls]="item.icon"
    >
      <span class="indicator"></span>
      <span
        class="material-symbols-outlined nav-icon"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="{{ item.title | translate }}"
        >{{ item.icon }}</span
      >
      <span class="text">{{ item.title | translate }}</span>
    </a>
    <div
      id="{{ item.icon }}"
      class="accordion-collapse collapse"
      [ngClass]="{ show: item.expanded }"
      data-bs-parent="#accordionExample"
    >
      <div class="accordion-body">
        <ul>
          @for (nestedItem of item.items; track nestedItem) {
          <li>
            @if (nestedItem.isVisible(user)) {
            <a
              href=""
              [routerLink]="[nestedItem.url]"
              routerLinkActive="active"
              [ngClass]="{ active: item.active }"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              id="{{ nestedItem.title }}"
              title="{{ nestedItem.title | translate }}"
              class="menu-item"
            >
              <span class="indicator"></span>
              <span class="material-symbols-outlined nav-icon">{{
                nestedItem.icon
              }}</span>
              <span class="text">{{ nestedItem.title | translate }}</span>
            </a>
            }
          </li>
          }
        </ul>
      </div>
    </div>
  </div>
  } } @else { @if (item.isVisible(user)) {
  <a
    class="menu-item"
    [routerLink]="[item.url]"
    [ngClass]="{ active: item.active }"
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    id="{{ item.title }}"
    title="{{ item.title | translate }}"
  >
    <span class="indicator"></span>
    <span class="material-symbols-outlined nav-icon">{{ item.icon }}</span>
    <span class="text">{{ translate(item.title) }}</span>
  </a>
  } } }
</div>
